import { render, staticRenderFns } from "./NorticListItem.vue?vue&type=template&id=2dcca14c&scoped=true&"
import script from "./NorticListItem.vue?vue&type=script&lang=js&"
export * from "./NorticListItem.vue?vue&type=script&lang=js&"
import style0 from "./NorticListItem.vue?vue&type=style&index=0&id=2dcca14c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcca14c",
  null
  
)

export default component.exports